import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: ${theme.v2.font.family.primary};
  `}
`;

export const Title = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.medium};
    text-align: center;
    color:${theme.v2.colors.brand.primaryExtraDark};
    margin-bottom: 16px;
    line-height: 150%;
    margin: 0;
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    color: ${theme.v2.colors.neutral.lowPure};
    text-align: center;
    line-height: 150%;

    &:first-child {
      margin-bottom: 24px;
    }

    &:not(:first-child) {
      margin-bottom: 16px;
    }
  `}
`;

export const InputAdapter = styled.div`
  ${({ theme }) => css`
    width: 100%;
    max-width: 400px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      max-width: 100%;
    }
  `}
`;

export const ButtonContainer = styled.div`
  ${() => css`
    align-items: center;
    display: flex;
    justify-content: center;
    gap: 24px;
  `}
`;
